module.exports = __webpack_public_path__ + "img/excel.682a5c3e.png";